'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

var Input = (function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    _classCallCheck(this, Input);

    _React$Component.apply(this, arguments);
  }

  Input.prototype.render = function render() {
    var _props = this.props;
    var _props$tagName = _props.tagName;
    var Tag = _props$tagName === undefined ? 'input' : _props$tagName;

    var props = _objectWithoutProperties(_props, ['tagName']);

    return React.createElement(Tag, _extends({}, props, { onChange: function (e) {
        return props.onChange(e.target.value);
      } }));
  };

  return Input;
})(React.Component);

module.exports = Input;


//////////////////
// WEBPACK FOOTER
// ./~/react-formal/lib/inputs/Input.js
// module id = 792
// module chunks = 0